jQuery(document).ready(function($) {
  const plyrSelector = 'player';

  if(document.getElementById(plyrSelector) !== null) {
    const player = new Plyr('#' + plyrSelector);
    const buttonPlay = '.c-video__button--play';
    const buttonClose = '.c-video__button--close';

    $(buttonPlay).on('click', function() {
      $(this).addClass('is-hidden');
      $(buttonClose).removeClass('is-hidden');
      $('#' + plyrSelector).parent().addClass('is-active');
      player.play();
    });

    $(buttonClose).on('click', function() {
      player.pause();
      $('#' + plyrSelector).parent().removeClass('is-active');
      $(this).addClass('is-hidden');
      $(buttonPlay).removeClass('is-hidden');
    });
  }
});
